import { Sidebar } from "@devhop/ui";

interface AppSidebarProps extends React.ComponentProps<typeof Sidebar> {}

export function AppSidebar({ ...props }: AppSidebarProps) {
  return <Sidebar {...props} collapsible="icon" variant="inset" />;
}
